module.exports = __webpack_public_path__ + "img/ltkswim-2x.2e68d2e.jpg";